import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useRightColumnContext } from 'Context/RightColumnContext';
import Drawer from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Drawer';
import React from 'react';
import {
  FDPaper, FDSecondaryActionIconButton, FDStack,
} from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { dataAttrs } from 'Helpers/Testing';
import metaOverrideSet from './metaOverrideSet';

const ThreadHistoryDrawer = () => {
  const theme = useTheme();

  const {
    rightColumnCollection,
    showRightColumnCollection,
    clearRightColumnCollection,
  } = useRightColumnContext();

  const threadHistoryResource = rightColumnCollection.resources().head();

  return (
    <Drawer
      open={showRightColumnCollection}
      onClose={clearRightColumnCollection}
      anchor={'right'}
    >
      <FDPaper
        flexGrow={1}
        appearance={'flat'}
        rounded={false}
        width={theme.dimensions.md}
        padding={4}
        {...dataAttrs('thread-history-drawer')}
      >
        <FDStack direction={'column'} spacing={4}>
          <FDStack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
            <MetaControl attrName={'title'} resource={threadHistoryResource} metaOverrideSet={metaOverrideSet} />
            <FDSecondaryActionIconButton
              onClick={clearRightColumnCollection}
              icon={'close'}
            />
          </FDStack>
          <MetaControl attrName={'modelOutput'} resource={threadHistoryResource} metaOverrideSet={metaOverrideSet} />
          <MetaControl
            attrName={'routingHistoryItems'}
            resource={threadHistoryResource}
            metaOverrideSet={metaOverrideSet}
            CustomProps={{
              label: threadHistoryResource.meta().field('routingHistoryItems').attr('prompt'),
            }}
          />
          <MetaControl attrName={'externalSystemLink'} resource={threadHistoryResource} metaOverrideSet={metaOverrideSet} />
        </FDStack>
      </FDPaper>
    </Drawer>
  );
};

ThreadHistoryDrawer.defaultProps = {
};

ThreadHistoryDrawer.propTypes = {};

export default ThreadHistoryDrawer;
